import * as featureFlags from './feature-flags'

export const start = async (env, isGTI) => {
  const redirectHost = env.VIRUSTOTAL_UI_ROOT
  const redirectPath = '/collection/'
  const urlPatternsToBeRedirected = new Map([
    ['/actors/', 'vt_redirect_actors'],
    ['/campaigns/', 'vt_redirect_campaigns'],
    ['/malware/', 'vt_redirect_malwares']
  ])

  window.addEventListener('single-spa:routing-event', event => {
    const { pathname } = new URL(event.detail.newUrl)

    // Iterate over the map entries
    for (const [pattern, featureFlag] of urlPatternsToBeRedirected.entries()) {
      if (pathname.startsWith(pattern) && isGTI && featureFlags.get(featureFlag)) {
        const id = pathname.split('/').pop()
        window.location.replace(`${redirectHost}${redirectPath}${id}`)
        return // Stop after the first match
      }
    }
  })
}
